import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AircraftProfileSkeleton,
  AircraftProfileEngineAudit,
  EngineAudit,
  AircraftProfileComponentAudit,
  ComponentAudit,
  AircraftPerformanceAudit,
  PhoneNumberAudit,
  PostFlightVisibilityAudit,
  AircraftProfileAudit,
  AddressAudit,
  EmailAddressAudit,
  ColorSettingAudit,
  AircraftRelationAudit,
  AircraftRelationSkeleton,
  ColorSettingSkeleton,
  AircraftProfileEngineSkeleton,
  AircraftProfileComponentSkeleton,
  AircraftPerformanceSkeleton,
  PostFlightVisibilitySkeleton,
  AircraftBillingRateSkeleton,
  AircraftBillingRateAudit
} from '../+models/aircraft-profile-audit.model';
import { AircraftProfileFacade } from '../+state/aircraft-profile/aircraft-profile.facade';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';
import { AircraftRelationAuditListComponent } from './aircraft-relation-audit-list/aircraft-relation-audit-list.component';
import { ColorSettingAuditListComponent } from './color-setting-audit-list/color-setting-audit-list.component';
import { EngineAuditListComponent } from './engine-audit-list/engine-audit-list.component';
import { ComponentAuditListComponent } from './component-audit-list/component-audit-list.component';
import { AircraftProfileAuditListComponent } from './aircraft-profile-audit-list/aircraft-profile-audit-list.component';
import { PostFlightVisibilityAuditListComponent } from './postflight-visibility-audit-list/postflight-visibility-audit-list.component';
import { PerformanceAuditListComponent } from './performance-audit-list/performance-audit-list.component';
import { AircraftBillingRateAuditListComponent } from './aircraft-billing-rate-audit-list/aircraft-billing-rate-audit-list.component';
import { AircraftBillingRateType } from '@sd-portal/shared/aircraft';
import { enumToArray } from '@sd-portal/shared/functions';

@Component({
  selector: 'sd-portal-aircraft-profile-audit',
  templateUrl: './aircraft-profile.component.html',
  styleUrls: ['./aircraft-profile.component.scss']
})
export class AircraftProfileComponent implements OnInit {
  colorSettingAuditsLoaded$: Observable<boolean>;
  colorSettingAuditsLoading$: Observable<boolean>;
  colorSettingAudits$: Observable<ColorSettingAudit[]>;

  aircraftProfileSkeletonLoaded$: Observable<boolean>;
  aircraftProfileSkeletonLoading$: Observable<boolean>;
  aircraftProfileSkeleton$: Observable<AircraftProfileSkeleton | null | undefined>;

  aircraftRelationTypesLoaded$: Observable<boolean>;
  aircraftRelationTypesLoading$: Observable<boolean>;
  aircraftRelationTypes$: Observable<RefTypeItem[]>;

  postFlightVisibilityTypesLoaded$: Observable<boolean>;
  postFlightVisibilityTypesLoading$: Observable<boolean>;
  postFlightVisibilityTypes$: Observable<RefTypeItem[]>;

  aircraftProfileEngineAuditsLoaded$: Observable<boolean>;
  aircraftProfileEngineAuditsLoading$: Observable<boolean>;
  aircraftProfileEngineAudits$: Observable<AircraftProfileEngineAudit[]>;

  engineAuditsLoaded$: Observable<boolean>;
  engineAuditsLoading$: Observable<boolean>;
  engineAudits$: Observable<EngineAudit[]>;

  aircraftProfileComponentAuditsLoaded$: Observable<boolean>;
  aircraftProfileComponentAuditsLoading$: Observable<boolean>;
  aircraftProfileComponentAudits$: Observable<AircraftProfileComponentAudit[]>;

  componentAuditsLoaded$: Observable<boolean>;
  componentAuditsLoading$: Observable<boolean>;
  componentAudits$: Observable<ComponentAudit[]>;

  aircraftPerformanceAuditsLoaded$: Observable<boolean>;
  aircraftPerformanceAuditsLoading$: Observable<boolean>;
  aircraftPerformanceAudits$: Observable<AircraftPerformanceAudit[]>;

  aircraftRelationAuditsLoaded$: Observable<boolean>;
  aircraftRelationAuditsLoading$: Observable<boolean>;
  aircraftRelationAudits$: Observable<AircraftRelationAudit[]>;

  phoneNumberAuditsLoaded$: Observable<boolean>;
  phoneNumberAuditsLoading$: Observable<boolean>;
  phoneNumberAudits$: Observable<PhoneNumberAudit[]>;

  faxNumberAuditsLoaded$: Observable<boolean>;
  faxNumberAuditsLoading$: Observable<boolean>;
  faxNumberAudits$: Observable<PhoneNumberAudit[]>;

  postFlightVisibilityAuditsLoaded$: Observable<boolean>;
  postFlightVisibilityAuditsLoading$: Observable<boolean>;
  postFlightVisibilityAudits$: Observable<PostFlightVisibilityAudit[]>;

  aircraftBillingRateAuditsLoaded$: Observable<boolean>;
  aircraftBillingRateAuditsLoading$: Observable<boolean>;
  aircraftBillingRateAudits$: Observable<AircraftBillingRateAudit[]>;

  aircraftProfileAuditsLoaded$: Observable<boolean>;
  aircraftProfileAuditsLoading$: Observable<boolean>;
  aircraftProfileAudits$: Observable<AircraftProfileAudit[]>;

  addressAuditsLoaded$: Observable<boolean>;
  addressAuditsLoading$: Observable<boolean>;
  addressAudits$: Observable<AddressAudit[]>;

  emailAddressAuditsLoaded$: Observable<boolean>;
  emailAddressAuditsLoading$: Observable<boolean>;
  emailAddressAudits$: Observable<EmailAddressAudit[]>;

  @ViewChildren(ColorSettingAuditListComponent)
  colorSettingAuditLists: QueryList<ColorSettingAuditListComponent>;
  @ViewChildren(EngineAuditListComponent) engineAuditLists: QueryList<EngineAuditListComponent>;
  @ViewChildren(ComponentAuditListComponent)
  componentAuditLists: QueryList<ComponentAuditListComponent>;
  @ViewChildren(PerformanceAuditListComponent)
  aircraftPerformanceAuditLists: QueryList<PerformanceAuditListComponent>;
  @ViewChildren(AircraftProfileAuditListComponent)
  aircraftProfileAuditLists: QueryList<AircraftProfileAuditListComponent>;
  @ViewChildren(AircraftRelationAuditListComponent)
  aircraftRelationAuditLists: QueryList<AircraftRelationAuditListComponent>;
  @ViewChildren(PostFlightVisibilityAuditListComponent)
  postFlightVisibilityAuditLists: QueryList<PostFlightVisibilityAuditListComponent>;
  @ViewChildren(AircraftBillingRateAuditListComponent)
  aircraftBillingRateAuditLists: QueryList<AircraftBillingRateAuditListComponent>;

  private readonly aircraftBillingRateTypes = enumToArray(AircraftBillingRateType);

  constructor(private readonly aircraftProfileFacade: AircraftProfileFacade) {}

  ngOnInit() {
    this.aircraftProfileSkeletonLoaded$ = this.aircraftProfileFacade.aircraftProfileSkeletonLoaded$;
    this.aircraftProfileSkeletonLoading$ =
      this.aircraftProfileFacade.aircraftProfileSkeletonLoading$;
    this.aircraftProfileSkeleton$ = this.aircraftProfileFacade.aircraftProfileAuditSkeleton$;

    this.aircraftRelationTypesLoaded$ = this.aircraftProfileFacade.aircraftRelationTypesLoaded$;
    this.aircraftRelationTypesLoading$ = this.aircraftProfileFacade.aircraftRelationTypesLoading$;
    this.aircraftRelationTypes$ = this.aircraftProfileFacade.aircraftRelationTypes$;

    this.postFlightVisibilityTypesLoaded$ =
      this.aircraftProfileFacade.postFlightVisibilityTypesLoaded$;
    this.postFlightVisibilityTypesLoading$ =
      this.aircraftProfileFacade.postFlightVisibilityTypesLoading$;
    this.postFlightVisibilityTypes$ = this.aircraftProfileFacade.postFlightVisibilityTypes$;

    this.aircraftProfileEngineAuditsLoaded$ =
      this.aircraftProfileFacade.aircraftProfileEngineAuditsLoaded$;
    this.aircraftProfileEngineAuditsLoading$ =
      this.aircraftProfileFacade.aircraftProfileEngineAuditsLoading$;
    this.aircraftProfileEngineAudits$ = this.aircraftProfileFacade.aircraftProfileEngineAudits$;

    this.engineAuditsLoaded$ = this.aircraftProfileFacade.engineAuditsLoaded$;
    this.engineAuditsLoading$ = this.aircraftProfileFacade.engineAuditsLoading$;
    this.engineAudits$ = this.aircraftProfileFacade.engineAudits$;

    this.aircraftProfileComponentAuditsLoaded$ =
      this.aircraftProfileFacade.aircraftProfileComponentAuditsLoaded$;
    this.aircraftProfileComponentAuditsLoading$ =
      this.aircraftProfileFacade.aircraftProfileComponentAuditsLoading$;
    this.aircraftProfileComponentAudits$ =
      this.aircraftProfileFacade.aircraftProfileComponentAudits$;

    this.componentAuditsLoaded$ = this.aircraftProfileFacade.componentAuditsLoaded$;
    this.componentAuditsLoading$ = this.aircraftProfileFacade.componentAuditsLoading$;
    this.componentAudits$ = this.aircraftProfileFacade.componentAudits$;

    this.colorSettingAuditsLoaded$ = this.aircraftProfileFacade.colorSettingAuditsLoaded$;
    this.colorSettingAuditsLoading$ = this.aircraftProfileFacade.colorSettingAuditsLoading$;
    this.colorSettingAudits$ = this.aircraftProfileFacade.colorSettingAudits$;

    this.aircraftPerformanceAuditsLoaded$ =
      this.aircraftProfileFacade.aircraftPerformanceAuditsLoaded$;
    this.aircraftPerformanceAuditsLoading$ =
      this.aircraftProfileFacade.aircraftPerformanceAuditsLoading$;
    this.aircraftPerformanceAudits$ = this.aircraftProfileFacade.aircraftPerformanceAudits$;

    this.aircraftRelationAuditsLoaded$ = this.aircraftProfileFacade.aircraftRelationAuditsLoaded$;
    this.aircraftRelationAuditsLoading$ = this.aircraftProfileFacade.aircraftRelationAuditsLoading$;
    this.aircraftRelationAudits$ = this.aircraftProfileFacade.aircraftRelationAudits$;

    this.phoneNumberAuditsLoaded$ = this.aircraftProfileFacade.phoneNumberAuditsLoaded$;
    this.phoneNumberAuditsLoading$ = this.aircraftProfileFacade.phoneNumberAuditsLoading$;
    this.phoneNumberAudits$ = this.aircraftProfileFacade.phoneNumberAudits$;

    this.faxNumberAuditsLoaded$ = this.aircraftProfileFacade.faxNumberAuditsLoaded$;
    this.faxNumberAuditsLoading$ = this.aircraftProfileFacade.faxNumberAuditsLoading$;
    this.faxNumberAudits$ = this.aircraftProfileFacade.faxNumberAudits$;

    this.postFlightVisibilityAuditsLoaded$ =
      this.aircraftProfileFacade.postFlightVisibilityAuditsLoaded$;
    this.postFlightVisibilityAuditsLoading$ =
      this.aircraftProfileFacade.postFlightVisibilityAuditsLoading$;
    this.postFlightVisibilityAudits$ = this.aircraftProfileFacade.postFlightVisibilityAudits$;

    this.aircraftBillingRateAuditsLoaded$ =
      this.aircraftProfileFacade.aircraftBillingRateAuditsLoaded$;
    this.aircraftBillingRateAuditsLoading$ =
      this.aircraftProfileFacade.aircraftBillingRateAuditsLoading$;
    this.aircraftBillingRateAudits$ = this.aircraftProfileFacade.aircraftBillingRateAudits$;

    this.aircraftProfileAuditsLoaded$ = this.aircraftProfileFacade.aircraftProfileAuditsLoaded$;
    this.aircraftProfileAuditsLoading$ = this.aircraftProfileFacade.aircraftProfileAuditsLoading$;
    this.aircraftProfileAudits$ = this.aircraftProfileFacade.aircraftProfileAudits$;

    this.addressAuditsLoaded$ = this.aircraftProfileFacade.addressAuditsLoaded$;
    this.addressAuditsLoading$ = this.aircraftProfileFacade.addressAuditsLoading$;
    this.addressAudits$ = this.aircraftProfileFacade.addressAudits$;

    this.emailAddressAuditsLoaded$ = this.aircraftProfileFacade.emailAddressAuditsLoaded$;
    this.emailAddressAuditsLoading$ = this.aircraftProfileFacade.emailAddressAuditsLoading$;
    this.emailAddressAudits$ = this.aircraftProfileFacade.emailAddressAudits$;

    this.aircraftProfileFacade.loadAircraftProfileAudit();
  }

  loadAddressAudits(addressId: number) {
    this.aircraftProfileFacade.loadAddressAudits(addressId);
  }
  nextAddressAuditPage(addressId: number) {
    this.aircraftProfileFacade.nextAddressAuditPage(addressId);
  }

  loadAircraftRelationAudits(aircraftRelationId: number) {
    this.aircraftProfileFacade.loadAircraftRelationAudits(aircraftRelationId);
  }
  nextAircraftRelationAuditPage(aircraftRelationId: number) {
    this.aircraftProfileFacade.nextAircraftRelationAuditPage(aircraftRelationId);
  }
  aircraftRelationOpened(aircraftRelation: AircraftRelationSkeleton) {
    setTimeout(() => {
      const match = this.aircraftRelationAuditLists.find(
        c => c.aircraftRelation === aircraftRelation
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadColorSettingAudits(colorSettingId: number) {
    this.aircraftProfileFacade.loadColorSettingAudits(colorSettingId);
  }
  nextColorSettingAuditPage(colorSettingId: number) {
    this.aircraftProfileFacade.nextColorSettingAuditPage(colorSettingId);
  }
  colorSettingOpened(colorSetting: ColorSettingSkeleton) {
    setTimeout(() => {
      const match = this.colorSettingAuditLists.find(
        c => c.colorSettingId === colorSetting.colorSettingId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadEngineAudits(engine: { aircraftProfileEngineId: number; engineId: number }) {
    this.aircraftProfileFacade.loadProfileEngineAudits(engine.aircraftProfileEngineId);
    this.aircraftProfileFacade.loadEngineAudits(engine.engineId);
  }
  nextEngineAuditPage(engine: { aircraftProfileEngineId: number; engineId: number }) {
    this.aircraftProfileFacade.nextAircraftProfileEngineAuditPage(engine.aircraftProfileEngineId);
    this.aircraftProfileFacade.nextEngineAuditPage(engine.engineId);
  }
  engineOpened(aircraftProfileEngine: AircraftProfileEngineSkeleton) {
    setTimeout(() => {
      const match = this.engineAuditLists.find(
        c => c.aircraftProfileEngineId === aircraftProfileEngine.aircraftProfileEngineId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadComponentAudits(component: { aircraftProfileComponentId: number; componentId: number }) {
    this.aircraftProfileFacade.loadProfileComponentAudits(component.aircraftProfileComponentId);
    this.aircraftProfileFacade.loadComponentAudits(component.componentId);
  }
  nextComponentAuditPage(component: { aircraftProfileComponentId: number; componentId: number }) {
    this.aircraftProfileFacade.nextAircraftProfileComponentAuditPage(
      component.aircraftProfileComponentId
    );
    this.aircraftProfileFacade.nextComponentAuditPage(component.componentId);
  }
  componentOpened(aircraftProfileComponent: AircraftProfileComponentSkeleton) {
    setTimeout(() => {
      const match = this.componentAuditLists.find(
        c => c.aircraftProfileComponentId === aircraftProfileComponent.aircraftProfileComponentId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadAircraftPerformanceAudits(aircraftPerformanceId: number) {
    this.aircraftProfileFacade.loadAircraftPerformanceAudits(aircraftPerformanceId);
  }
  nextAircraftPerformanceAuditPage(aircraftPerformanceId: number) {
    this.aircraftProfileFacade.nextAircraftPerformanceAuditPage(aircraftPerformanceId);
  }
  aircraftPerformanceOpened(aircraftPerformance: AircraftPerformanceSkeleton) {
    setTimeout(() => {
      const match = this.aircraftPerformanceAuditLists.find(
        c => c.aircraftPerformanceId === aircraftPerformance.aircraftPerformanceId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadPhoneNumberAudits(phoneNumberId: number) {
    this.aircraftProfileFacade.loadPhoneNumberAudits(phoneNumberId);
  }
  nextPhoneNumberAuditPage(phoneNumberId: number) {
    this.aircraftProfileFacade.nextPhoneNumberAuditPage(phoneNumberId);
  }

  loadFaxNumberAudits(phoneNumberId: number) {
    this.aircraftProfileFacade.loadFaxNumberAudits(phoneNumberId);
  }
  nextFaxNumberAuditPage(phoneNumberId: number) {
    this.aircraftProfileFacade.nextFaxNumberAuditPage(phoneNumberId);
  }

  loadEmailAddressAudits(emailAddressId: number) {
    this.aircraftProfileFacade.loadEmailAddressAudits(emailAddressId);
  }
  nextEmailAddressAuditPage(emailAddressId: number) {
    this.aircraftProfileFacade.nextEmailAddressAuditPage(emailAddressId);
  }

  loadPostFlightVisibilityAudits(postFlightVisibilityId: number) {
    this.aircraftProfileFacade.loadPostFlightVisibilityAudits(postFlightVisibilityId);
  }
  nextPostFlightVisibilityAuditPage(postFlightVisibilityId: number) {
    this.aircraftProfileFacade.nextPostFlightVisibilityAuditPage(postFlightVisibilityId);
  }
  postFlightVisibilityOpened(postFlightVisibility: PostFlightVisibilitySkeleton) {
    setTimeout(() => {
      const match = this.postFlightVisibilityAuditLists.find(
        c => c.postFlightVisibilityId === postFlightVisibility.postFlightVisibilityId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadAircraftBillingRateAudits(aircraftBillingRateId: number) {
    this.aircraftProfileFacade.loadAircraftBillingRateAudits(aircraftBillingRateId);
  }
  nextAircraftBillingRateAuditPage(aircraftBillingRateId: number) {
    this.aircraftProfileFacade.nextAircraftBillingRateAuditPage(aircraftBillingRateId);
  }
  aircraftBillingRateOpened(aircraftBillingRate: AircraftBillingRateSkeleton) {
    setTimeout(() => {
      const match = this.aircraftBillingRateAuditLists.find(
        c => c.aircraftBillingRateId === aircraftBillingRate.aircraftBillingRateId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  loadProfileAudits(aircraftProfileId: number) {
    this.aircraftProfileFacade.loadAircraftProfileAudits(aircraftProfileId);
  }
  nextProfileAuditPage(aircraftProfileId: number) {
    this.aircraftProfileFacade.nextAircraftProfileAuditPage(aircraftProfileId);
  }
  aircraftProfileOpened(aircraftProfile: AircraftProfileSkeleton) {
    setTimeout(() => {
      const match = this.aircraftProfileAuditLists.find(
        c => c.aircraftProfileId === aircraftProfile.aircraftProfileId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  getAircraftRelationTypeName(
    aircraftRelationTypes: RefTypeItem[],
    aircraftRelationTypeId: number
  ) {
    const aircraftRelationType = aircraftRelationTypes.find(r => r.id === aircraftRelationTypeId);
    if (!aircraftRelationType) {
      return '';
    }
    return aircraftRelationType.name;
  }

  getPostFlightVisibilityTypeName(
    postFlightVisibilityTypes: RefTypeItem[],
    postFlightVisibilityTypeId: number
  ) {
    const postFlightVisibilityType = postFlightVisibilityTypes.find(
      r => r.id === postFlightVisibilityTypeId
    );
    if (!postFlightVisibilityType) {
      return '';
    }
    return postFlightVisibilityType.name;
  }

  getAircraftBillingRateTypeName(aircraftBillingRateTypeId: number) {
    const aircraftBillingRateType = this.aircraftBillingRateTypes.find(
      r => r.key === aircraftBillingRateTypeId
    );
    if (!aircraftBillingRateType) {
      return '';
    }
    return aircraftBillingRateType.value;
  }
}
